import { render, staticRenderFns } from "./ItemSelectorRadio.vue?vue&type=template&id=391a2e72&scoped=true"
import script from "./ItemSelectorRadio.vue?vue&type=script&lang=js"
export * from "./ItemSelectorRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391a2e72",
  null
  
)

export default component.exports